
import {
    ApiCall
} from './index';

export const LOGIN_URL = "/login";
export const TOKEN_LOGIN_URL = "/token/login";

export const login = async(data) => {
    return await ApiCall('POST', LOGIN_URL, data);
};

export const tokenLogin = async() => {
    return await ApiCall('POST', TOKEN_LOGIN_URL);
};



// WEBPACK FOOTER //
// ./src/services/login.js